module.exports = __webpack_public_path__ + "img/login-logo-2-mb.26bdd3f9.jpg";